import React, { useState } from "react";
import { SummaryStats } from "@design-system/SummaryStats/SummaryStats";
import { BooleanControl, TextControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./DataDisplayPlayground.module.scss";

export const SummaryStatsPlayground = () => {
    const [trigger, setTrigger] = useState("Open: $12,480.25");
    const [hasPaymentBreakdown, setHasPaymentBreakdown] = useState(true);
    const [hasFees, setHasFees] = useState(true);
    const [hasTransactionCount, setHasTransactionCount] = useState(true);

    const sections = [
        ...(hasPaymentBreakdown
            ? [
                  [
                      { label: "Total open", value: "$12,480.25" },
                      { label: "Total paid", value: "$31,205.80" },
                  ],
              ]
            : []),
        ...(hasFees
            ? [
                  [
                      { label: "Processing fees", value: "$842.16" },
                      { label: "Net collected", value: "$30,363.64" },
                  ],
              ]
            : []),
        ...(hasTransactionCount
            ? [[{ label: "Transactions", value: "47" }]]
            : []),
    ];

    return (
        <SandboxLayout
            controls={
                <>
                    <section>
                        <h2>Trigger</h2>
                        <TextControl
                            label="Text"
                            value={trigger}
                            onChange={setTrigger}
                        />
                    </section>
                    <section>
                        <h2>Metrics</h2>
                        <div className={styles.booleanGrid}>
                            <BooleanControl
                                label="Payment breakdown"
                                checked={hasPaymentBreakdown}
                                onChange={setHasPaymentBreakdown}
                            />
                            <BooleanControl
                                label="Fees"
                                checked={hasFees}
                                onChange={setHasFees}
                            />
                            <BooleanControl
                                label="Transaction count"
                                checked={hasTransactionCount}
                                onChange={setHasTransactionCount}
                            />
                        </div>
                    </section>
                </>
            }
        >
            <ShowcasePreview
                summary={`${sections.flat().length} metrics`}
                output={JSON.stringify(
                    {
                        props: {
                            trigger,
                            sections,
                        },
                        showcase: {
                            hasPaymentBreakdown,
                            hasFees,
                            hasTransactionCount,
                        },
                    },
                    null,
                    2,
                )}
            >
                <div className={styles.surface}>
                    <SummaryStats trigger={trigger} sections={sections} />
                </div>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
